import axiosInstance from './../axiosInstance';

/**
 * Get single contact.
 *
 * @param {int} contactID
 */
export const getContact = contactID => {
  return axiosInstance.get('contacts/' + contactID);
};

/**
 * Get contacts.
 * @param {object} params
 */
export const getContacts = params => {
  return axiosInstance.get('contacts');
};

/**
 * Save contact information.
 *
 * @param {int} contactID
 * @param {object} values
 */
export const saveContact = (contactID, values) => {
  return axiosInstance.post('contacts/' + contactID, values);
};
